import { Injectable } from '@angular/core';

export interface ChartState {
    chartRequestIds: string[];
    tableRequestIds: string[];
}

@Injectable({
    providedIn: 'root'
})
export class ChartStateService {
    private readonly STORAGE_KEY = 'home-page-requests';

    saveChartState(chartIds: string[], tableIds: string[]): void {
       const state: ChartState = {
            chartRequestIds: (chartIds ?? []).slice(0, 2),
            tableRequestIds: (tableIds ?? []).slice(0, 2)
        };

        localStorage.setItem(this.STORAGE_KEY, JSON.stringify(state));
    }

    loadChartState(): ChartState {
        const empty: ChartState = {
            chartRequestIds: [],
            tableRequestIds: []
        };

        try {
            const stored = localStorage.getItem(this.STORAGE_KEY);
            return stored ? JSON.parse(stored) : empty;
        } catch (error) {
            console.warn('Failed to load chart state from localStorage:', error);
            return empty;
        }
    }

    clearChartState(): void {
        localStorage.removeItem(this.STORAGE_KEY);
    }
}
